import { IconProp, SizeProp } from "@fortawesome/fontawesome-svg-core"

export type CustomTableButtonProps = {
  label: string
  labelKey?: string
  icon: IconProp
  color?: "primary" | "secondary" | "error" | "info" | "success" | "warning"
}
export interface TableButtonProps {
  iconSize?: SizeProp
  type: TableButtonTypeEnum
  custom?: CustomTableButtonProps
  handleOnClick: () => void
  disabled?: boolean
}

export enum TableButtonTypeEnum {
  Custom = "custom",
  Edit = "edit",
  Delete = "delete",
  View = "view",
  Download = "download",
  Send = "send"
}
